import { ImportMapping } from './../../models/import-mapping';
// import { ISaleImportType } from '../../models/sale-ImportType';
// import { ICustomDataAttribute } from '../../models/custom-data/custom-data-attribute';

export namespace ImportType.Actions {
  export class GetImportTypes {
    public static readonly type = '[ImportType] Get Organization ImportTypes]';
    constructor() {}
  }

  export class GetImportType {
    public static readonly type = '[ImportType] Get Single ImportType]';
    constructor(public id: string) {}
  }

  export class UpdateImportType {
    public static readonly type = '[ImportType] Update Single ImportType]';
    constructor(public importType: ImportMapping) {}
  }

  export class DeleteImportType {
    public static readonly type = '[ImportType] Delete Single ImportType]';
    constructor(public importType: ImportMapping) {}
  }

  export class InsertImportType {
    public static readonly type = '[ImportType] Insert Single ImportType]';
    constructor(public importType: ImportMapping) {}
  }

  // export class GetImportTypeOrders {
  //   public static readonly type = '[ImportType] Get ImportType Orders';
  //   constructor(public organizationId: string, public ImportTypeId: string) {}
  // }
}
